import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ToolsAndMaterialsType } from '../../../shared/interfaces';
import { AppSettings } from '../../../shared/models';
import { AbstractBasicDataApiService } from '../abstract-basic-data-api.service';

@Injectable({
  providedIn: 'root'
})
export class ToolsAndMaterialsTypeApiService extends AbstractBasicDataApiService<ToolsAndMaterialsType> {

  constructor(
    protected http: HttpClient
  ) {
    super(http, AppSettings.endpoints.basicinformation.toolsAndMaterials.type);
  }
}
